import Vue from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from "./App.vue";
import {store} from "./store/store.js";
import Vue2TouchEvents from "vue2-touch-events";
import VueConfetti from 'vue-confetti'
import Notifications from 'vue-notification'
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'

import VueConfirmDialog from 'vue-confirm-dialog'

Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

// import VueSimpleAlert from "vue-simple-alert";
//
// Vue.use(VueSimpleAlert);

// Vue.prototype.$pusher = new Pusher('e50fb6be6b7df82fb347', {
//   cluster: 'ap2'
// });

// Vue.prototype.$pusher = new Pusher('60b70543fe2e5f6aaf34', {
//   cluster: 'ap1'
// });

// Vue.prototype.$pusher.logToConsole = true;

// if (!store.state.subscribed_channel && store.state.channel == null){
//   store.dispatch('subscribeToChannel',true);
// }else {
//   Vue.prototype.$channel = store.state.channel;
// }

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'e50fb6be6b7df82fb347',
  cluster: 'ap2',
  encrypted: true
});

Vue.use(CanvasVideo)
Vue.use(Notifications);

Vue.use(VueConfetti);
Vue.config.productionTip = false;

Vue.use(Vue2TouchEvents);
Vue.use(VueAxios, axios)
Vue.prototype.$appName = "Tuni";
//axios.defaults.headers.common['X-Frame-Options'] = 'ALLOWALL'
new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
